import { Stack } from "@mui/material";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { brandingAtom } from "../brand-kit/store";
import { TemplateCarouselImage } from "./template-carousel-image";
import { TemplateImagesCarousel } from "./template-images-carousel";

import type { Loadable } from "../../utils/jotai-loadable";
import type { LoadableTemplateImage, Template } from "../generic/atoms/types/template";
import type { StackProps } from "@mui/material";
import type { Atom } from "jotai";
import type { FC, ReactElement } from "react";

export const TemplateImages: FC<
  {
    loadableTemplateAtom: Atom<Loadable<Template | null>>;
    onSelect?: (n: number) => void;
    tooltip?: ReactElement;
    carousel?: boolean;
  } & Omit<StackProps, "onSelect">
> = ({ loadableTemplateAtom, onSelect, carousel = false, ...props }) => {
  const [images, setImages] = useState<LoadableTemplateImage[]>([]);

  const template = useAtomValue(loadableTemplateAtom);
  const { initialized } = useAtomValue(brandingAtom);
  const numImages = images ? images.length : 0;

  useEffect(() => {
    if (template?.state === "hasData") {
      setImages(
        initialized
          ? (template.data?.images ?? [])
          : Array(numImages).fill({ state: "hasData", data: null }),
      );
    }
  }, [template, initialized, setImages, numImages]);

  const selectedImage = template?.state === "hasData" ? template.data?.selectedImage : undefined;

  if (carousel)
    return (
      <TemplateImagesCarousel
        images={images}
        selectedImage={selectedImage}
        onSelect={onSelect}
        {...props}
      />
    );

  return (
    <Stack direction="row" gap={2} {...props}>
      {/* oxlint-disable-next-line typescript/no-unsafe-type-assertion */}
      {(images ?? (Array(numImages).fill(undefined) as undefined[])).map((ii, i) => (
        <TemplateCarouselImage
          key={`img-${i}`}
          image={ii}
          selected={selectedImage === i}
          onClick={() => onSelect?.(i)}
          sx={{
            opacity: selectedImage === i ? 1 : 0.8,
            width: "90px",
            height: "90px",
          }}
        />
      ))}
    </Stack>
  );
};
